// @flow
import type {Action} from '../../../state/types'

export type SetSelectedCityPayload = {
  city: Url,
}

const id = 'hospital/SET_SELECTED_CITY'

export const setSelectedCity = (city: Url): Action<SetSelectedCityPayload> => ({
  type: id,
  payload: {
    city,
  }
})

setSelectedCity.id = id
